import { pullUrlParams, urlDecodeJSON } from "@/lib/urlParams";
import type { TableLayoutState } from "@repo/ui/components/Base/DataTable";
import { useLocalStorageValue } from "./useLocalStorageValue";

export const useUserColumns = (
  key: string,
  defaultState: TableLayoutState = {}
) => {
  const storedValue = useLocalStorageValue<TableLayoutState>(key, defaultState);

  defaultState = storedValue.value;

  const saveTableLayout = (state: TableLayoutState) => {
    storedValue.setValue(state);
  };
  const resetTableLayout = () => {
    storedValue.resetValue();
  };

  const { layout } = pullUrlParams(true);
  if (layout) {
    try {
      defaultState = {
        ...defaultState,
        ...urlDecodeJSON(layout),
      };
    } catch (err) {
      // noop
    }
  }

  return { defaultState, saveTableLayout, resetTableLayout };
};
